import { AllUnitOptionValues, UnitCategory, UnitCategoryByOption } from '../constants/unit.options';
import { UnitConverter } from '../base/UnitConverter';
import { BitsUnitConverter } from '../converters/bits';
import { BinaryBytesUnitConverter } from '../converters/bytesBinary';
import { DecimalBytesUnitConverter } from '../converters/bytesDecimal';
import { BitsPerSecUnitConverter } from '../converters/bitsPerSec';
import { BinaryBytesPerSecUnitConverter } from '../converters/bytesBinaryPerSec';
import { CpuUnitConverter } from '../converters/cpu';
import { CurrentUnitConverter } from '../converters/current';
import { RatioUnitConverter } from '../converters/ratio';
import { PotentialUnitConverter } from '../converters/potential';
import { PowerUnitConverter } from '../converters/power';
import { TemperatureUnitConverter } from '../converters/temperature';
import { MoneyUnitConverter } from '../converters/money';
import { TimeUnitConverter } from '../converters/time';
import { FrequencyUnitConverter } from '../converters/frequency';
import { GeneralUnitConverter } from '../converters/general';

export class UnitConverterFactory {
  private static UnitConverterMap: Record<string, UnitConverter<string>> = {
    bits: BitsUnitConverter.getInstance(),
    'binary-bytes': BinaryBytesUnitConverter.getInstance(),
    'decimal-bytes': DecimalBytesUnitConverter.getInstance(),
    'bits-per-sec': BitsPerSecUnitConverter.getInstance(),
    'binary-bytes-per-sec': BinaryBytesPerSecUnitConverter.getInstance(),
    cpu: CpuUnitConverter.getInstance(),
    current: CurrentUnitConverter.getInstance(),
    ratio: RatioUnitConverter.getInstance(),
    potential: PotentialUnitConverter.getInstance(),
    power: PowerUnitConverter.getInstance(),
    temperature: TemperatureUnitConverter.getInstance(),
    money: MoneyUnitConverter.getInstance(),
    time: TimeUnitConverter.getInstance(),
    frequency: FrequencyUnitConverter.getInstance(),
    general: GeneralUnitConverter.getInstance(),
  };

  private static unitConverterByCategory: Record<
    UnitCategory,
    keyof typeof UnitConverterFactory.UnitConverterMap
  > = {
    '': 'general',
    APM: 'general',
    Bits: 'bits',
    'Bytes(binary)': 'binary-bytes',
    'Bytes(decimal)': 'decimal-bytes',
    'Bits/sec': 'bits-per-sec',
    'Bytes(binary)/sec': 'binary-bytes-per-sec',
    Cache: 'general',
    CPU: 'cpu',
    Current: 'current',
    DB: 'general',
    Disk: 'general',
    Frequency: 'frequency',
    General: 'general',
    Logging: 'general',
    Memory: 'general',
    Money: 'money',
    Network: 'general',
    Percentage: 'ratio',
    Potential: 'potential',
    Power: 'power',
    Synthetic: 'general',
    System: 'general',
    Temperature: 'temperature',
    Time: 'time',
  };

  static getInstance(unit: AllUnitOptionValues | (string & {})) {
    const category = UnitCategoryByOption[unit] ?? '';
    const converterKey = this.unitConverterByCategory[category];

    return this.UnitConverterMap[converterKey];
  }
}
